import { ErrorPage } from "@/components/Error/ErrorPage";
import { FullSizeLoader } from "@/design-system/FullSizeLoader";
import { useTranslation } from "@/translations";

import { BulkILoqEditor } from "./BulkILoqEditor";
import { PortfolioIntegrationWorkspace } from "./PortfolioIntegrationWorkspace";
import { ILoqProjectSetupQueue } from "./ProjectSetupQueue";
import { usePortfolioILoqProjects } from "./usePortfolioIntegrationProjects";

/** Manages portfolio-wide iLOQ configuration and project-specific setup. */
export function ILoqPortfolioIntegrationPage(): React.ReactNode {
  const { t } = useTranslation();
  const projects = usePortfolioILoqProjects();

  if (projects.error) {
    return <ErrorPage error={projects.error} />;
  }
  if (projects.isLoading) {
    return <FullSizeLoader withPadding />;
  }

  return (
    <PortfolioIntegrationWorkspace
      name={t("page.integration.iloq.title")}
      description={t("page.portfolio-integrations.workspace.description")}
      rows={projects.rows}
      showIntegrationStatus
      renderBulkEditor={({ rows, selectedProjectIds, onContinueToProjectSetup }) => (
        <BulkILoqEditor
          rows={rows}
          selectedProjectIds={selectedProjectIds}
          onContinueToProjectSetup={onContinueToProjectSetup}
        />
      )}
      renderProjectSetup={({ rows, selectedProjectIds }) => (
        <ILoqProjectSetupQueue rows={rows} selectedProjectIds={selectedProjectIds} />
      )}
    />
  );
}
